import { formatCurrency } from '../../../lib/format';
import { useT } from '../../../locales';
import type { EstadoCuentaApplication } from '@aid/shared';

/**
 * Invoice-side application detail (T35 / S2): which payment (or credit lot)
 * settled the invoice, the amount applied and the application state. The
 * association comes from the estado-de-cuenta query; nothing is recomputed
 * here. Renders nothing when the invoice has no applications, so legacy
 * invoices keep exactly their current shape.
 */
export function InvoiceApplications({
  applications,
}: {
  applications?: EstadoCuentaApplication[];
}) {
  const t = useT();
  if (!applications || applications.length === 0) return null;

  const stateLabel = (estado: string) => {
    const translated = t(`pages.clientes.estadoCuenta.estado.${estado}`);
    return typeof translated === 'string' && translated.startsWith('pages.') ? estado : translated;
  };

  return (
    <details>
      <summary style={{ cursor: 'pointer', fontSize: 12 }}>
        {t('pages.clientes.estadoCuenta.aplicaciones', { count: applications.length })}
      </summary>
      <ul className="estado-cuenta__mobile-application-list">
        {applications.map((application) => {
          const source =
            application.idPago !== null
              ? t('pages.clientes.estadoCuenta.aplicacionPago', { id: application.idPago })
              : t('pages.clientes.estadoCuenta.aplicacionCredito', {
                  id: application.idCredito ?? application.id,
                });
          return (
            <li key={application.id}>
              {source}: {formatCurrency(application.montoAplicado)} (
              {stateLabel(application.estado)})
            </li>
          );
        })}
      </ul>
    </details>
  );
}
